import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bridge-monitoring"
  }, [_vm.isPaused ? _c(VAlert, {
    staticClass: "monitoring-info-banner d-inline-block mb-6",
    attrs: {
      "color": _vm.color,
      "outlined": "",
      "dense": "",
      "icon": "fal fa-info-circle"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.pausedBanner')) + "\n  ")]) : _vm._e(), _c(VRow, {
    staticClass: "mb-4"
  }, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.charts.title')))]), _c('p', {
    staticClass: "text--secondary text-caption mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.formatTimeRange(_vm.timeRange.from, _vm.timeRange.to)) + "\n      ")])]), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-end flex-wrap"
  }, [_vm.isPaused ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-play",
      "data-cy": "start_monitoring"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('start-monitoring');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.enableButton')) + "\n        ")]) : _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-pause",
      "data-cy": "pause_monitoring"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('pause-monitoring');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.actions.pause')) + "\n        ")]), _c('core-button', {
    attrs: {
      "color": "danger",
      "prepend-icon": "fa-trash-alt",
      "data-cy": "stop_delete_monitoring"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('stop-delete-monitoring');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.actions.stopDelete')) + "\n        ")]), _c(VSelect, {
    staticClass: "ml-2",
    staticStyle: {
      "max-width": "292px",
      "min-width": "180px"
    },
    attrs: {
      "items": _vm.timeFrames,
      "item-text": "name",
      "return-object": "",
      "label": _vm.$i18n_t('Connectors.Monitoring.charts.timespan'),
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.handleTimeFrameChange
    },
    model: {
      value: _vm.selectedTimeFrame,
      callback: function ($$v) {
        _vm.selectedTimeFrame = $$v;
      },
      expression: "selectedTimeFrame"
    }
  }), _c(VBtn, {
    class: 'v-btn-x ml-2 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.update'),
      "icon": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.refreshCharts
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-sync-alt")])], 1)], 1)])], 1), _c('bridge-monitoring-charts', {
    ref: "charts",
    attrs: {
      "bridge-id": _vm.bridgeId,
      "tenant-id": _vm.tenantId,
      "time-range": _vm.timeRange
    }
  }), _c(VDivider, {
    staticClass: "my-8"
  }), _c('bridge-monitoring-rules', {
    attrs: {
      "bridge-id": _vm.bridgeId,
      "monitoring-config-id": _vm.monitoringConfig.id,
      "monitoring-config": _vm.monitoringConfig,
      "tenant-id": _vm.tenantId
    },
    on: {
      "rule-updated": function ($event) {
        return _vm.$emit('config-changed');
      }
    }
  }), _c(VDivider, {
    staticClass: "my-8"
  }), _c(VRow, {
    staticClass: "mb-4"
  }, [_c(VCol, [_c('h3', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.title')))]), _c('p', {
    staticClass: "text--secondary text-caption mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.description')) + "\n      ")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "5"
    }
  }, [_c(VSheet, {
    staticClass: "pa-4",
    attrs: {
      "rounded": "",
      "color": _vm.panelColor
    }
  }, [_c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.label')) + "\n        ")]), _c('p', {
    staticClass: "text--secondary text-caption mb-6"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.description')) + "\n        ")]), _c(VSelect, {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.emailConnectors,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.connector'),
      "hint": _vm.emailConnectors.length === 0 ? _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.noConnectorsHint') : '',
      "persistent-hint": _vm.emailConnectors.length === 0,
      "item-text": "name",
      "item-value": "id",
      "item-disabled": "disabled",
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VListItem, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.noConnectorsTitle')) + "\n                ")]), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.noConnectorsSubtitle')) + "\n                ")])], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.emailSettings.connectorId,
      callback: function ($$v) {
        _vm.$set(_vm.emailSettings, "connectorId", $$v);
      },
      expression: "emailSettings.connectorId"
    }
  }), _c(VTextField, {
    staticClass: "mb-3",
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.senderEmail'),
      "disabled": !_vm.emailSettings.connectorId,
      "outlined": "",
      "type": "email",
      "placeholder": "noreply@example.com"
    },
    model: {
      value: _vm.emailSettings.senderEmail,
      callback: function ($$v) {
        _vm.$set(_vm.emailSettings, "senderEmail", $$v);
      },
      expression: "emailSettings.senderEmail"
    }
  }), _c(VTextField, {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.recipientEmail'),
      "disabled": !_vm.emailSettings.connectorId,
      "outlined": "",
      "type": "email",
      "placeholder": "alerts@example.com"
    },
    model: {
      value: _vm.emailSettings.recipientEmail,
      callback: function ($$v) {
        _vm.$set(_vm.emailSettings, "recipientEmail", $$v);
      },
      expression: "emailSettings.recipientEmail"
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.emailSettings.connectorId || _vm.savingEmail,
      "loading": _vm.savingEmail,
      "prepend-icon": "fa-save"
    },
    on: {
      "click": _vm.saveEmailSettings
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.save')) + "\n          ")])], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VSheet, {
    staticClass: "pa-4",
    attrs: {
      "rounded": "",
      "color": _vm.panelColor
    }
  }, [_c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.evaluationInterval.label')) + "\n        ")]), _c('p', {
    staticClass: "text--secondary text-caption mb-6"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.evaluationInterval.description')) + "\n        ")]), _c(VSelect, {
    attrs: {
      "items": _vm.evaluationIntervalOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.evaluationInterval.label'),
      "outlined": "",
      "hide-details": "",
      "suffix": "min"
    },
    on: {
      "change": _vm.updateEvaluationInterval
    },
    model: {
      value: _vm.evaluationIntervalMinutes,
      callback: function ($$v) {
        _vm.evaluationIntervalMinutes = $$v;
      },
      expression: "evaluationIntervalMinutes"
    }
  })], 1)], 1), false ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c(VSheet, {
    staticClass: "pa-4",
    attrs: {
      "rounded": "",
      "color": _vm.panelColor
    }
  }, [_c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.label')) + "\n        ")]), _c('p', {
    staticClass: "text--secondary text-caption mb-6"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.description')) + "\n        ")]), _c(VSelect, {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.webhookConnectors,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.connector'),
      "hint": _vm.webhookConnectors.length === 0 ? _vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.noConnectorsHint') : '',
      "persistent-hint": _vm.webhookConnectors.length === 0,
      "item-text": "name",
      "item-value": "id",
      "item-disabled": "disabled",
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VListItem, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.noConnectorsTitle')) + "\n                ")]), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.noConnectorsSubtitle')) + "\n                ")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 1688632065),
    model: {
      value: _vm.webhookSettings.connectorId,
      callback: function ($$v) {
        _vm.$set(_vm.webhookSettings, "connectorId", $$v);
      },
      expression: "webhookSettings.connectorId"
    }
  }), _c(VSelect, {
    staticClass: "mb-4",
    attrs: {
      "items": _vm.webhookFormatOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.format'),
      "disabled": !_vm.webhookSettings.connectorId,
      "outlined": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-code")])];
      },
      proxy: true
    }], null, false, 2037395117),
    model: {
      value: _vm.webhookSettings.format,
      callback: function ($$v) {
        _vm.$set(_vm.webhookSettings, "format", $$v);
      },
      expression: "webhookSettings.format"
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.webhookSettings.connectorId || _vm.savingWebhook,
      "loading": _vm.savingWebhook,
      "prepend-icon": "fa-save"
    },
    on: {
      "click": _vm.saveWebhookSettings
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.save')) + "\n          ")])], 1)], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };